import { ReactNode } from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/Card";
import { Form } from "@/components/ui/form";
import { FieldValues, UseFormReturn } from "react-hook-form";
import { cn } from "@/util/cn";

type FormCardProps<T extends FieldValues> = {
  title: string;
  description?: string;
  form: UseFormReturn<T>;
  children: ReactNode;
  className?: string;
  onSubmit: (data: T) => void;
};

export function FormCard<T extends FieldValues>({
  title,
  description,
  form,
  onSubmit,
  children,
  className,
}: FormCardProps<T>) {
  return (
    <div className={cn("w-full max-w-lg mx-auto", className)}>
      <Card className="bg-brand-neutral-800 border-transparent shadow-none">
        <CardHeader>
          <CardTitle className="text-2xl tracking-tight">{title}</CardTitle>
          {description && <CardDescription>{description}</CardDescription>}
        </CardHeader>
        <CardContent>
          <Form {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)}>
              <div className="flex flex-col gap-6">{children}</div>
            </form>
          </Form>
        </CardContent>
      </Card>
    </div>
  );
}
